import React, { useState } from "react";
import propTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import HeaderComponent from "components/Layout/HeaderComponent";
import TopHeaderSearchComponents from "components/TopHeaderSearchComponents";
import { getStorageData, setStorageData } from "utils/helper";
import { pageType, DOMAIN_CLINKS } from "constants/app";
import { FaSearch } from "react-icons/fa";
import FooterComponent from "components/Layout/FooterComponent";
import Offcanvas from "react-bootstrap/Offcanvas";
import Clinks_bg from "assets/images/clinks_bg.jpg";
import Home_bg from "assets/images/home_bg.jpg";
import SearchClinksOrgList from "pages/SearchClinksOrgList";
import classNames from "classnames";
import { useStyles } from "./styles";
const Home = (props) => {
  const classes = useStyles(props);
  const navigate = useNavigate();
  const { formData, setFormData } = props;
  const [searchStatus, setSearchStatus] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const domain = getStorageData("domain");
  const onSearchClick = () => {
    if (
      formData?.pathway?.length ||
      formData?.name ||
      formData?.county?.length
    ) {
      setSearchStatus(false);
      setStorageData("user_data", formData);
      navigate("/clinks-list");
      return true;
    }
    setSearchStatus(true);
    return false;
  };
  return (
    <>
      {domain === DOMAIN_CLINKS ? (
        <SearchClinksOrgList {...props} />
      ) : (
        <div
          style={{
            backgroundImage: `url(${
              domain === DOMAIN_CLINKS ? Clinks_bg : Home_bg
            })`,
          }}
          className={classNames(
            classes.landing__page,
            "landing__pageCommon position-relative"
          )}
        >
          <HeaderComponent
            className="bg-transparent w-100"
            isPage={pageType.home}
            {...props}
          />
          <div className="lp__body d-flex flex-column justify-content-center align-items-center w-100 pb-5 position-relative z-2">
            <Container fluid="xxl">
              <div className="lp__title mx-auto text-center mb-4">
                <h2 className="text-white mb-3">
                  Contrary to popular belief, Lorem Ipsum is not simply random
                  text. It has roots in a piece of classical Latin literature
                  from 45 BC, making it.
                </h2>
                <p className="text-white">
                  There are many variations of passages of Lorem Ipsum.
                </p>
              </div>
              {/* Search Bar */}
              <TopHeaderSearchComponents
                formData={formData}
                setFormData={setFormData}
                onSearchClick={onSearchClick}
                className="d-lg-flex d-none flex-wrap justify-content-center lanp__search rounded-pill"
                isPage={"home"}
                searchStatus={searchStatus}
                setSearchStatus={setSearchStatus}
              />
              {/* lp__mobile__search */}
              <div className="mobile__hsearch w-100 d-inline-flex d-lg-none">
                <div
                  className="mobile__form w-100 d-flex align-items-center justify-content-between gap-2"
                  onClick={handleShow}
                >
                  <div class="mobile__forml">
                    <h4 className="m-0 fw-semibold text-dark opacity-75">
                      Click to search organisation
                    </h4>
                  </div>
                  <div class="mobile__formr opacity-25">
                    <FaSearch />
                  </div>
                </div>
                <Offcanvas
                  show={show}
                  onHide={handleClose}
                  placement={"bottom"}
                  backdrop="static"
                  className="mobile__hsearchf"
                >
                  <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Search organisation</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body>
                    <TopHeaderSearchComponents
                      formData={formData}
                      setFormData={setFormData}
                      onSearchClick={onSearchClick}
                      className="d-flex flex-wrap justify-content-center lanp__search rounded-pill"
                      isPage={"home"}
                      searchStatus={searchStatus}
                      setSearchStatus={setSearchStatus}
                    />
                  </Offcanvas.Body>
                </Offcanvas>
              </div>
            </Container>
          </div>
          <FooterComponent />
        </div>
      )}
    </>
  );
};
Home.propTypes = {
  history: propTypes.object,
};
export default Home;
